import { InjectionToken } from '@angular/core';

export const REQUEST = new InjectionToken('http_server_request');
export const REPLY = new InjectionToken('http_server_reply');
export const UTILS = new InjectionToken('http_utils');
